import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ScopeAuthorizationService } from '@mds/ngx-auth';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { DeploymentsClient } from '../../../../../shared/services/api-client';

export const canEditDeploymentGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const scopeAuthorizationService = inject(ScopeAuthorizationService);
  const apiClient = inject(DeploymentsClient);

  const deploymentIdValue =
    route.paramMap.get('deploymentId') ??
    route.parent?.paramMap.get('deploymentId');

  const deploymentId = deploymentIdValue
    ? Number(deploymentIdValue)
    : Number.NaN;

  if (!Number.isFinite(deploymentId)) {
    return router.parseUrl('/error/404');
  }

  return apiClient.getAuthorizationRequirement(deploymentId).pipe(
    take(1),
    switchMap((requirements) => {
      const requiredScopes = requirements.requiredScopes ?? [];
      if (requiredScopes.length === 0) {
        return of(true);
      }

      return scopeAuthorizationService.hasScopes(requiredScopes).pipe(
        take(1),
        map((canWrite) => (canWrite ? true : router.parseUrl('/error/403'))),
      );
    }),
    catchError(() => of(router.parseUrl('/error/500'))),
  );
};
